export default {
  TEXT: 'rgba(0,0,0,1)',
  BACKGROUND: 'rgba(255,255,255,1)',
};
